// src/data/eurovisionData.tsx

// Define our data types
export interface Participant {
    id: number;
    name: string;        // Artist name
    country: string;     // Country name
    countryCode: string; // Two-letter code for flag/heart icons
    songTitle: string;   // Song title
    description: string; // Detailed description
    image: string;       // Artist image
    videoId: string;     // YouTube video ID
    odds: number;        // Betting odds
}
  
export interface Event {
id: number;
name: string;
maxRankings: number;
}
  
// Sample data for Eurovision participants
export const eurovisionParticipants: Participant[] = [
{
    id: 1,
    name: "Shkodra Elektronike",
    country: "Albania",
    countryCode: "AL",
    songTitle: "Zjerm",
    description: "Albania's entry brings traditional Balkan sounds fused with modern electronic beats. The powerful vocals and dynamic performance create an unforgettable Eurovision moment.",
    image: "/artists/albania.jpg",
    videoId: "Sfvb761EEcM", // Sample video ID
    odds: 34.00
},
{
    id: 2,
    name: "Tommy Cash",
    country: "Estonia",
    countryCode: "EE",
    songTitle: "Espresso macchiato",
    description: "Estonia's Tommy Cash delivers a unique blend of electronic music with avant-garde visuals. His distinctive style and charismatic stage presence make for a memorable performance.",
    image: "/artists/estonia.jpg",
    videoId: "5MS_Fczs_98", // Sample video ID
    odds: 29.00
},
{
    id: 3,
    name: "Sissal",
    country: "Denmark",
    countryCode: "DK",
    songTitle: "Hallucination",
    description: "Denmark's Sissal brings a haunting melody with Nordic influences. The ethereal vocals combined with modern production create a captivating Eurovision entry.",
    image: "/artists/denmark.jpg",
    videoId: "gdCAgiSIOUc", // Sample video ID
    odds: 201.00
},
{
    id: 4,
    name: "Go-Jo",
    country: "Australia",
    countryCode: "AU",
    songTitle: "Milkshake Man",
    description: "Australia's Eurovision 2025 act features an exhilarating pop anthem, highlighting exceptional vocals, creative choreography, and captivating visuals, aiming to enchant audiences and secure top votes.",
    image: "/artists/australia.jpg",
    videoId: "_08I6mjHSLA", // Sample video ID
    odds: 81.00
},
{
    id: 5,
    name: "KAJ",
    country: "Sweden",
    countryCode: "SE",
    songTitle: "Bara Bada Bastu",
    description: "Sweden brings another pop masterpiece to Eurovision. With slick production, catchy hooks, and polished choreography, this entry continues Sweden's strong Eurovision legacy.",
    image: "/artists/sweden.jpg",
    videoId: "WK3HOMhAeQY", // Sample video ID
    odds: 2.75
},
{
  id: 6,
  name: "Erika Vikman",
  country: "Finland",
  countryCode: "FI",
  songTitle: "ICH KOMME",
  description: "Finland's Eurovision 2025 act delivers an explosive mix of rock and contemporary music, captivating audiences with energetic performances, intense vocals, and striking stage visuals.",
  image: "/artists/finland.jpg",
  videoId: "Kg3QoTpnqyw", // Sample video ID
  odds: 21.00
},
{
  id: 7,
  name: "Abor & Tynna",
  country: "Germany",
  countryCode: "DE",
  songTitle: "Baller",
  description: "Germany's Eurovision 2025 entry showcases a lively fusion of pop and classical influences, combining powerful vocals with dynamic choreography and mesmerizing visual effects.",
  image: "/artists/germany.jpg",
  videoId: "zJplC4-9Scs", // Sample video ID
  odds: 101.00
},
{
  id: 8,
  name: "Red Sebastian",
  country: "Belgium",
  countryCode: "BE",
  songTitle: "Strobe Lights",
  description: "Belgium's Eurovision 2025 act brings a techno-inspired vibe with powerful beats and striking visuals, captivating the audience with its high energy and modern flair.",
  image: "/artists/belgium.jpg",
  videoId: "ScupiVTosHU", // Sample video ID
  odds: 26.00
},
{
  id: 9,
  name: "Melody",
  country: "Spain",
  countryCode: "ES",
  songTitle: "ESA DIVA",
  description: "Spain's Eurovision 2025 entry delivers a passionate fusion of flamenco and contemporary pop, featuring emotive vocals, dynamic dance moves, and vibrant visual elements that capture the audience's heart.",
  image: "/artists/spain.jpg",
  videoId: "BvVxhbCW9rw", // Sample video ID
  odds: 126.00
},
{
  id: 10,
  name: "EMMY",
  country: "Ireland",
  countryCode: "IE",
  songTitle: "Laika Party",
  description: "Ireland's Eurovision 2025 act showcases a heartfelt blend of folk and indie pop, featuring soulful vocals, poignant lyrics, and enchanting stage visuals that resonate deeply with the audience.",
  image: "/artists/ireland.jpg",
  videoId: "cZnusVb7yjs", // Sample video ID
  odds: 101.00
},
{
  id: 11,
  name: "ADONXS",
  country: "Czechia",
  countryCode: "CZ",
  songTitle: "Kiss Kiss Goodbye",
  description: "Czechia's Eurovision 2025 act brings an eclectic mix of electronic and indie pop, offering catchy rhythms, engaging vocals, and a visually dynamic performance that enthralls audiences.",
  image: "/artists/czechia.jpg",
  videoId: "Hm8CIICKAJU", // Sample video ID
  odds: 51.00
},
{
  id: 12,
  name: "Louane",
  country: "France",
  countryCode: "FR",
  songTitle: "maman",
  description: "France's Eurovision 2025 entry features a chic blend of chanson and modern pop, characterized by elegant vocals, captivating melodies, and sophisticated stage visuals, aiming to enchant and leave a lasting impression.",
  image: "/artists/france.jpg",
  videoId: "Pj2DTSLcNnI", // Sample video ID
  odds: 6.50
},
{
  id: 13,
  name: "NAPA",
  country: "Portugal",
  countryCode: "PT",
  songTitle: "Deslocado",
  description: "Portugal's Eurovision 2025 act combines rich fado influences with contemporary music, delivering a deeply emotional performance with soulful vocals, expressive melodies, and visually compelling stage presence.",
  image: "/artists/portugal.jpg",
  videoId: "-s1Cc2uEj3U", // Sample video ID
  odds: 301.00
},
{
  id: 14,
  name: "Klemen",
  country: "Slovenia",
  countryCode: "SI",
  songTitle: "How Much Time Do We Have Left",
  description: "Slovenia's Eurovision 2025 entry combines folk elements with edgy rock, featuring powerful vocals, energetic guitar riffs, and dynamic stage visuals, creating a captivating and thrilling performance.",
  image: "/artists/slovenia.jpg",
  videoId: "GT1YhfRpq3Q", // Sample video ID
  odds: 201.00
},
{
  id: 15,
  name: "Princ",
  country: "Serbia",
  countryCode: "RS",
  songTitle: "Mila",
  description: "Serbia's Eurovision 2025 act delivers an impactful blend of ethno-pop and modern beats, featuring strong vocals, compelling rhythms, and vibrant stage visuals, captivating the audience with its dynamic presence.",
  image: "/artists/serbia.jpg",
  videoId: "18BCbtvDcag", // Sample video ID
  odds: 301.00
},
{
  id: 16,
  name: "Theo Evan",
  country: "Cyprus",
  countryCode: "CY",
  songTitle: "Shh",
  description: "Cyprus's Eurovision 2025 entry features an exciting mix of Mediterranean rhythms and contemporary pop, showcasing powerful vocals, engaging dance moves, and vibrant visuals that captivate and energize the audience.",
  image: "/artists/cyprus.jpg",
  videoId: "rbfQqWyqgJw", // Sample video ID
  odds: 81.00
},
{
  id: 17,
  name: "Klavdia",
  country: "Greece",
  countryCode: "GR",
  songTitle: "Asteromáta",
  description: "Greece's Eurovision 2025 act blends traditional Greek music with modern pop, presenting captivating vocals, rhythmic melodies, and visually stunning performances that both celebrate heritage and enchant the audience.",
  image: "/artists/greece.jpg",
  videoId: "aDiq8J9h6vQ", // Sample video ID
  odds: 101.00
},
{
  id: 18,
  name: "Mariam Shengelia",
  country: "Georgia",
  countryCode: "GE",
  songTitle: "Freedom",
  description: "Georgia's Eurovision 2025 entry presents an imaginative fusion of avant-garde sounds and traditional Georgian influences, combining haunting vocals, intricate melodies, and visually striking stagecraft that captivates and fascinates audiences.",
  image: "/artists/georgia.jpg",
  videoId: "c3wu0dUNd4c", // Sample video ID
  odds: 301.00
},
{
  id: 19,
  name: "Nina Žižić",
  country: "Montenegro",
  countryCode: "ME",
  songTitle: "Dobrodošli",
  description: "Montenegro's Eurovision 2025 act showcases a dramatic mix of Balkan influences and modern pop elements, featuring emotive vocals, compelling instrumentals, and visually captivating staging that engages and enchants the audience.",
  image: "/artists/montenegro.jpg",
  videoId: "ydMkpaB0CWk", // Sample video ID
  odds: 301.00
},
{
  id: 20,
  name: "Lucio Corsi",
  country: "Italy",
  countryCode: "IT",
  songTitle: "Volevo Essere Un Duro",
  description: "Italy's Eurovision 2025 entry offers a sophisticated blend of classic Italian balladry and contemporary pop, showcasing powerful vocals, heartfelt lyrics, and elegant visuals that resonate deeply with audiences.",
  image: "/artists/italy.jpg",
  videoId: "-Alz9MnqyZI", // Sample video ID
  odds: 81.00
},
{
  id: 21,
  name: "Mamagama",
  country: "Azerbaijan",
  countryCode: "AZ",
  songTitle: "Run With U",
  description: "Azerbaijan's Eurovision 2025 act combines traditional Mugham elements with modern pop, delivering a captivating performance marked by compelling vocals, mesmerizing melodies, and striking stage visuals that enthrall the audience.",
  image: "/artists/azerbaijan.jpg",
  videoId: "upbiPJ9uA70", // Sample video ID
  odds: 126.00
},
{
  id: 22,
  name: "VÆB",
  country: "Iceland",
  countryCode: "IS",
  songTitle: "RÓA",
  description: "Iceland's Eurovision 2025 entry presents an enchanting mix of ethereal sounds and alternative pop, featuring atmospheric vocals, captivating melodies, and innovative stage visuals that transport and mesmerize the audience.",
  image: "/artists/iceland.jpg",
  videoId: "s9P83Nl6D1M", // Sample video ID
  odds: 301.00
},
{
  id: 23,
  name: "JJ",
  country: "Austria",
  countryCode: "AT",
  songTitle: "Wasted Love",
  description: "Austria's Eurovision 2025 act features a striking fusion of orchestral elements and synth-pop, showcasing powerful vocals, dynamic arrangements, and visually captivating performances that engage and inspire audiences.",
  image: "/artists/austria.jpg",
  videoId: "-ieSTNpxvio", // Sample video ID
  odds: 3.50
},
{
  id: 24,
  name: "Gabry Ponte",
  country: "San Marino",
  countryCode: "SM",
  songTitle: "Tutta L'Italia",
  description: "San Marino's Eurovision 2025 entry delivers a lively blend of dance-pop and electronic music, featuring energetic performances, catchy hooks, and vibrant stage visuals designed to captivate and entertain the audience.",
  image: "/artists/sanmarino.jpg",
  videoId: "Le3WpaLYRvE", // Sample video ID
  odds: 67.00
},
{
  id: 25,
  name: "Ziferblat",
  country: "Ukraine",
  countryCode: "UA",
  songTitle: "Bird of Pray",
  description: "Ukraine's Eurovision 2025 act is a masterful blend of traditional folk elements and contemporary soundscapes, featuring haunting vocals, evocative melodies, and visually powerful staging that captivates and resonates with the audience.",
  image: "/artists/ukraine.jpg",
  videoId: "OJ1x2aiL7ks", // Sample video ID
  odds: 51.00
},
{
  id: 26,
  name: "PARG",
  country: "Armenia",
  countryCode: "AM",
  songTitle: "SURVIVOR",
  description: "Armenia's Eurovision 2025 entry combines rich traditional Armenian music with modern pop influences, presenting memorable vocals, intricate rhythms, and stunning visual effects that create a deeply impactful and captivating performance.",
  image: "/artists/armenia.jpg",
  videoId: "RfH5o3XtI2c", // Sample video ID
  odds: 301.00
},
{
  id: 27,
  name: "Laura Thorn",
  country: "Luxembourg",
  countryCode: "LU",
  songTitle: "La Poupée Monte Le Son",
  description: "Luxembourg's Eurovision 2025 act offers a sophisticated mix of jazz-infused pop, featuring smooth vocals, elegant melodies, and stylish stage visuals designed to charm and captivate audiences.",
  image: "/artists/luxembourg.jpg",
  videoId: "LVHu_KwHiKY", // Sample video ID
  odds: 301.00
},
{
  id: 28,
  name: "Katarsis",
  country: "Lithuania",
  countryCode: "LT",
  songTitle: "Tavo Akys",
  description: "Lithuania's Eurovision 2025 entry presents an eclectic blend of indie-pop and electronic music, featuring distinctive vocals, creative rhythms, and visually innovative staging that captivates and energizes the audience.",
  image: "/artists/lithuania.jpg",
  videoId: "R2f2aZ6Fy58", // Sample video ID
  odds: 126.00
},
{
  id: 29,
  name: "Tautumeitas",
  country: "Latvia",
  countryCode: "LV",
  songTitle: "Bur Man Laimi",
  description: "Latvia's Eurovision 2025 act delivers a vibrant mix of alternative pop and electronic beats, showcasing catchy hooks, charismatic vocals, and visually dynamic staging that captivates and engages audiences.",
  image: "/artists/latvia.jpg",
  videoId: "RKw0OCgPV3s", // Sample video ID
  odds: 301.00
},
{
  id: 30,
  name: "Marko Bošnjak",
  country: "Croatia",
  countryCode: "HR",
  songTitle: "Poison Cake",
  description: "Croatia's Eurovision 2025 entry features a compelling blend of traditional Balkan sounds and contemporary pop, marked by emotive vocals, captivating melodies, and striking visual elements that resonate deeply with the audience.",
  image: "/artists/croatia.jpg",
  videoId: "ie_v6qGCc5w", // Sample video ID
  odds: 301.00
},
{
  id: 31,
  name: "Yuval Raphael",
  country: "Israel",
  countryCode: "IL",
  songTitle: "New Day Will Rise",
  description: "Israel's Eurovision 2025 act offers a dynamic fusion of Middle Eastern influences and modern pop, featuring powerful vocals, catchy melodies, and vibrant stage visuals that captivate and energize the audience.",
  image: "/artists/israel.jpg",
  videoId: "Q3BELu4z6-U", // Sample video ID
  odds: 11.00
},
{
  id: 32,
  name: "Justyna Steczkowska",
  country: "Poland",
  countryCode: "PL",
  songTitle: "GAJA",
  description: "Poland's Eurovision 2025 entry blends traditional Polish folk elements with contemporary pop, showcasing heartfelt vocals, engaging rhythms, and visually captivating performances that connect with and enchant audiences.",
  image: "/artists/poland.jpg",
  videoId: "YXHHDjiclxA", // Sample video ID
  odds: 201.00
},
{
  id: 33,
  name: "Kyle Alessandro",
  country: "Norway",
  countryCode: "NO",
  songTitle: "Lighter",
  description: "Norway's Eurovision 2025 act delivers a captivating mix of Nordic folk and modern synth-pop, featuring ethereal vocals, enchanting melodies, and visually stunning stagecraft that transports and fascinates the audience.",
  image: "/artists/norway.jpg",
  videoId: "pUjWzQ671MQ", // Sample video ID
  odds: 201.00
},
{
  id: 34,
  name: "Miriana Conte",
  country: "Malta",
  countryCode: "MT",
  songTitle: "SERVING",
  description: "Malta's Eurovision 2025 entry presents an infectious blend of upbeat pop and Mediterranean influences, showcasing vibrant vocals, lively rhythms, and captivating visuals that engage and energize the audience.",
  image: "/artists/malta.jpg",
  videoId: "sLVSwfRRvMA", // Sample video ID
  odds: 71.00
},
{
  id: 35,
  name: "Claude",
  country: "Netherlands",
  countryCode: "NL",
  songTitle: "C'est La Vie",
  description: "The Netherlands' Eurovision 2025 act features a striking blend of soulful balladry and contemporary pop, characterized by emotive vocals, heartfelt lyrics, and elegant visuals that deeply resonate with audiences.",
  image: "/artists/netherlands.jpg",
  videoId: "hEHwr5k9pd0", // Sample video ID
  odds: 17.00
},
{
  id: 36,
  name: "Zoë Më",
  country: "Switzerland",
  countryCode: "CH",
  songTitle: "Voyage",
  description: "Switzerland's Eurovision 2025 entry offers a harmonious blend of classical music and modern pop, featuring powerful vocals, lush arrangements, and visually sophisticated staging that captivates and enchants the audience.",
  image: "/artists/switzerland.jpg",
  videoId: "dGX54zRExR8", // Sample video ID
  odds: 126.00
},
{
  id: 37,
  name: "Remember Monday",
  country: "United Kingdom",
  countryCode: "GB",
  songTitle: "What The Hell Just Happened?",
  description: "The United Kingdom's Eurovision 2025 act delivers a vibrant fusion of Britpop and modern rock, showcasing energetic vocals, catchy hooks, and dynamic stage visuals designed to captivate and engage the audience.",
  image: "/artists/greatbritain.jpg",
  videoId: "-hu6R3ZnOdY", // Sample video ID
  odds: 101.00
}
];

// Events data
export const events: Event[] = [
  { id: 1, name: 'Eurovision 2025', maxRankings: 5 },
  { id: 2, name: 'Eurovision Semifinal', maxRankings: 3 }
];

// Type for user submissions
export interface UserSubmission {
    id: string;           // Unique ID (timestamp + random)
    email: string;        // User's email
    username: string;     // User's name/username
    country: string;      // User's country
    ranking: number[];    // Array of participant IDs in ranked order
    timestamp: number;    // Submission time
    score?: number;       // Score (calculated after event)
  }
  
  // Utility functions for storing/retrieving submissions
  export const submissionUtils = {
    // Save a new submission
    saveSubmission: (email: string, username: string, country: string, ranking: Participant[]): UserSubmission => {
      const submission: UserSubmission = {
        id: Date.now() + '-' + Math.random().toString(36).substr(2, 9),
        email,
        username,
        country,
        ranking: ranking.map(p => p.id),
        timestamp: Date.now()
      };
      
      // Get existing submissions
      const existingData = localStorage.getItem('eurovisionSubmissions');
      const submissions: UserSubmission[] = existingData ? JSON.parse(existingData) : [];
      
      // Add new submission
      submissions.push(submission);
      
      // Save back to localStorage
      localStorage.setItem('eurovisionSubmissions', JSON.stringify(submissions));
      
      return submission;
    },
    
    // Get all submissions
    getSubmissions: (): UserSubmission[] => {
      const data = localStorage.getItem('eurovisionSubmissions');
      return data ? JSON.parse(data) : [];
    },
    
    // Sample function to calculate scores (would be based on actual results)
    calculateHighScores: (): UserSubmission[] => {
      const submissions = submissionUtils.getSubmissions();
      
      // This is where you'd compare with actual results
      // For now, we'll simulate scores based on timestamp (newer = better)
      const scoredSubmissions = submissions.map(sub => ({
        ...sub,
        score: Math.floor(Math.random() * 100) // Random score for demonstration
      }));
      
      // Sort by score (highest first)
      return scoredSubmissions.sort((a, b) => (b.score || 0) - (a.score || 0));
    }
  };